import React, { memo } from 'react';
import PropTypes from 'prop-types';
import parseHTML from 'html-react-parser';
import Wrapper from '../Wrapper';
import { withTitle } from '../../HOC';
import { getClassModifiers } from '../../utils';
import { CODE } from '../../constants';
import { wrapScriptTags } from './helpers';

const Code = memo(({ code: embedCode, parserOptions, disableWrapper, ...otherProps }) => {
  if (!embedCode) return null;

  const parsedCode = parseHTML(embedCode, parserOptions);
  const wrappedCode = wrapScriptTags(parsedCode);
  const modifiers = getClassModifiers(CODE, { ...otherProps });

  if (disableWrapper) return wrappedCode;

  return <Wrapper modifiers={modifiers}>{wrappedCode}</Wrapper>;
});

Code.propTypes = {
  code: PropTypes.string,
  modifier: PropTypes.string,
  parserOptions: PropTypes.object,
  disableWrapper: PropTypes.bool
};

Code.defaultProps = {
  code: '',
  modifier: '',
  parserOptions: {},
  disableWrapper: false
};

export default withTitle(Code);
